import { FormControl, FormErrorMessage, Input } from '@chakra-ui/react'
import React, { useState, useRef } from 'react'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import ja from 'date-fns/locale/ja'
import { Controller } from 'react-hook-form'
import styles from './style.module.scss'


const EDateRangePicker = ({
  disabled,
  dateFormat = 'yyyy-MM-dd',
  name,
  getValues,
  reset,
  placeholder,
  control,
  style,
  wrapperClassName = null,
  enableSelectRange = false,
}) => {
  const [dateRange, setDateRange] = useState([
    getValues(name) ? getValues(name)[0] : null,
    getValues(name) ? getValues(name)[1] : null
  ]);
  const [startDate, endDate] = dateRange;
  const inputRef = useRef(null);

  const onChangeDateRange = (dates, field) => {
    setDateRange(dates);
    field.onChange(dates);
  }

  const onChange = (dates) => {
    reset({ ...getValues(), [name]: dates })
  }

  const onBlur = (field) => {
    if (enableSelectRange && (startDate === null || endDate === null)) {
      setDateRange([null, null])
      field.onChange([null, null])
      if (inputRef.current) {
        inputRef.current.value = ''
      }
    }
  }

  registerLocale('ja', ja)

  return (
    <Controller
      style={{width:"100%"}}
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <FormControl isInvalid={!!error}>
          <ReactDatePicker
            onBlur={() => onBlur(field)}
            onChange={enableSelectRange ? (dates) => onChangeDateRange(dates, field) : onChange}
            selected={enableSelectRange ? undefined : getValues(name)}
            disabled={disabled}
            customInput={<Input fontSize={'14px'} sx={style} />}
            placeholderText={placeholder}
            locale='ja'
            wrapperClassName={wrapperClassName ? wrapperClassName : styles.searchEmployeeDatePicker}
            dateFormat={dateFormat}
            selectsRange={enableSelectRange}
            isClearable={enableSelectRange}
            startDate={startDate}
            endDate={endDate}
          />
          <FormErrorMessage fontSize={'14px'}>{error && error.message}</FormErrorMessage>
        </FormControl>
      )}
    />
  )
}

export default EDateRangePicker
